<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">Patient Overview: Medical History</h2>

        <ul class="list-disc pl-4  font-light">
            <li>Has the patient been previously seen or treated for any symptoms of PH1?</li>
        </ul>

        <img
            src="@/assets/img/graphics/eskd/medical-history-v2.svg"
            alt="Primary Clinical Manifestations in PH1"
            class="hidden md:block"
        />
        <img
            src="@/assets/img/graphics/eskd/eskd-medical-history-mobile.svg"
            alt="Primary Clinical Manifestations in PH1"
            class="md:hidden self-center"
        />
    </div>
</template>
